import React, { useState } from 'react'
import {PlayIcon, PlusIcon, XIcon} from '@heroicons/react/outline'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { contentInput, contentMessage } from '../../recoil/content'

const VideoLinkInput = () => {
  const [input, setInput] = useRecoilState(contentInput);
  const setMessage = useSetRecoilState(contentMessage);
  const [link, setLink] = useState('');

  const addLink = () => {
    if (link !== '') {
      let newInput = {...input};
      newInput.videos = Object.assign([], newInput.videos);
      newInput.videos.push(link);
      setInput(newInput);
      setLink('');
    } else {
      setMessage({
        success: false,
        text: 'Video link tidak boleh kosong!',
      });
    }
  };

  const removeLink = (i) => {
    let newInput = {...input};
    newInput.videos = Object.assign([], newInput.videos);
    newInput.videos.splice(i, 1);
    setInput(newInput);
  };

  const loadLinks = () => {
    if (input.videos.length === 0) {
      return (
        <div className="flex items-center gap-1 italic cursor-default text-slate-500">
          <span>Isi link video kemudian tekan icon </span>
          <PlusIcon className="w-5 h-5" />
        </div>
      );
    }
    return (
      <div className="flex flex-col gap-3">
          {
              input.videos.map((item, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 px-3 py-2 rounded-lg hover:bg-slate-100">
                      <a href={item} target="_blank" rel="noreferrer" className="flex-1 cursor-pointer overflow-clip hover:text-blue-600">{item}</a>
                      <XIcon className='w-5 h-5 cursor-pointer hover:text-red-500' onClick={() => removeLink(i)} />
                  </div>
              ))
          }
      </div>
  );
  };

  return (
    <div className="flex flex-col items-start">
        <label htmlFor="videos" className="text-sm">Link Video</label>
        <div className="flex items-start w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
            <PlayIcon className="w-6 h-6" />
            <div className="flex flex-col flex-1 gap-3">
                <input type="text" onChange={e => setLink(e.target.value)} value={link} name="videos" id="videos" className="w-full p-0 bg-transparent border-none focus:ring-0" placeholder="Link Video" />
                {loadLinks()}
            </div>
            <PlusIcon onClick={addLink} className="w-6 h-6 cursor-pointer hover:text-blue-600" />
        </div>
    </div>
  )
}

export default VideoLinkInput